import { type JSX } from 'react';

import { InfoIcon } from '../icons';

import { NoContentText, NoContentWrapper } from './style';

interface NoContentProps {
  children: React.ReactNode;
  lazyLoadIcon?: boolean;
}

export const NoContent = ({ children }: NoContentProps): JSX.Element => (
  <NoContentWrapper>
    <InfoIcon />
    <NoContentText data-testid="no-content-text">{children}</NoContentText>
  </NoContentWrapper>
);
